import React        from 'react';
import { connect }  from 'react-redux';

import { clearLoginFailed } from '../actions';

import Masthead       from './Masthead';
import { Page }       from 'moovila-common';
import { Splash }     from 'moovila-common';
import { MessageBox } from 'moovila-common';

const Login = ({loggedIn, clearLoginFailed}) => {
  let messageBox = null;
  if (loggedIn.message) {
    let title = loggedIn.title || '';
    const failedCallback = (e) => {
      e.preventDefault();
      clearLoginFailed();
    }
    messageBox = (
      <MessageBox title={title} backTo='/login' callback={failedCallback}>
        <div>{loggedIn.message}</div>
      </MessageBox>
    );
  }
  return (
    <div>
      <Masthead />
      <Page>
        <Splash imgFile='moovila_internal_console.png' />
      </Page>
      { messageBox }
    </div>
  );
}

export default connect(state => state, {
  clearLoginFailed,
})(Login);



// WEBPACK FOOTER //
// ./src/components/Login.js